<script setup lang="ts">
import { useSessionStore } from '../../../stores';
import { PracticeDataType, PracticePostMessage } from '../../../types/session';
import Iframe from '../../General/Iframe.vue';
import { useEventListener } from '@vueuse/core';

const sessionStore = useSessionStore()

function handlePostMessage(message: PracticePostMessage) {
    if (message.data.type !== PracticeDataType.update_item_info) return;

    sessionStore.setPracticeResult(message.data.result)
}

useEventListener(window, 'message', handlePostMessage)
</script>

<template>
    <div class="h-full flex flex-col items-center justify-evenly overflow-auto">
        <Iframe v-if="sessionStore.practiceUrl"
            :src="sessionStore.practiceUrl" />
    </div>
</template>